// extracted by mini-css-extract-plugin
export var filterIncDec = "_ex-0";
export var leftBorder = "_ex-1";
export var rightBorder = "_ex-2";
export var stringInput = "_ex-3";